import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "style-guide-heading" }, "Horizontal Spacing", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-giant" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-giant")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-huge" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-huge")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xxxl" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xxxl")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xxl" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xxl")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xl" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xl")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-lg" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-lg")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-md" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-md")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-sm" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-sm")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xs" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xs")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xxs" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xxs")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-xxxs" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-xxxs")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-nano" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-nano")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-display" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box spacing_inline-quark" }),
  /*#__PURE__*/_createElementVNode("code", null, "$spacing_inline-quark")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    id: "horizontal-spacing",
    class: "style-guide--spacing-horizontal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}